import { render, staticRenderFns } from "./FormCorrelationMapping.vue?vue&type=template&id=36cabf3e&scoped=true"
import script from "./FormCorrelationMapping.vue?vue&type=script&lang=ts"
export * from "./FormCorrelationMapping.vue?vue&type=script&lang=ts"
import style0 from "./FormCorrelationMapping.vue?vue&type=style&index=0&id=36cabf3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cabf3e",
  null
  
)

export default component.exports